import React from 'react'
import Box from '@material-ui/core/Box'
import SectionTitle from 'components/section-title'
import UpcomingLessons from './upcoming-lessons'
import NeedsAttention from './needs-attention'
import useStyles from './styles'

const ManageBusiness = ({ upcomingLessons, lessonsLoading }) => {
  const classes = useStyles()

  return (
    <Box className={classes.section}>
      <SectionTitle size="large" className={classes.sectionTitle}>
        Manage your coaching business
      </SectionTitle>
      <Box className={classes.grid}>
        <NeedsAttention />
        <UpcomingLessons lessons={upcomingLessons} loading={lessonsLoading} />
      </Box>
    </Box>
  )
}

export default ManageBusiness
